import {
  TypographyStylesProvider,
  Code,
  Image,
  ActionIcon,
} from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconApps,
  IconArrowsUpDown,
  IconPencil,
  IconPlugConnected,
  IconPlus,
  IconUsers,
} from "@tabler/icons-react";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const NOSTR_WALLET_CONNECT_SEND_AND_RECEIVE_CONTENT = (
  <TypographyStylesProvider>
    <p>
      {" "}
      Your Rizful node can be connected to external apps and websites via Nostr
      Wallet Connect (NWC), a new and experimental protocol that allows you to
      send and receive payments using your Rizful node.{" "}
    </p>

    <p>
      Please be aware that by using this protocol to send funds, you are
      engaging with a <strong>very new</strong> and{" "}
      <strong>very experimental</strong> technology. You should not use this
      with large satoshi balances.
    </p>

    <p> You can get started by clicking the "Apps" button.</p>

    <DocsButton
      ariaLabel="add apps"
      text="Apps"
      leftSection={<IconApps />}
      disabled={false}
    />

    <p>Click the "Get Connection Code" button.... </p>
    <SimpleImage
      h={450}
      src="docs_images/get-connection-code-send-receive.png"
    />

    {/* <SimpleImage
      h={250}
      src="docs_images/new-send-and-receive-panel-has-appeared.png"
    />
    <p>
      {" "}
      Click the{" "}
      <Code>
        <IconPencil
          style={{
            width: "1.2em",
            height: "1.2em",
            position: "relative",
            left: "-1px", // Adjusts horizontal position (nudge left)
            top: "4px", // Adjusts vertical position (nudge down)
          }}
        />{" "}
        Edit
      </Code>{" "}
      button to review the connection:
    </p>
    <SimpleImage h={520} src="docs_images/edit-nwc-connection.png" />
    <p>
      {" "}
      Looking at this screen, we can see that, by default, a Send & Receive
      connection can spend up to 100,000 satoshis every thirty (30) days, and
      expires in three (3) years. You can change these settings now, if you
      want.
    </p>
    <p>
      {" "}
      Keep in mind that any app you use this connection with could spend this
      amount at ANY TIME.{" "}
      <strong>
        {" "}
        ⚠️ If you provided this connection code to a malicious app, it could
        drain your entire budget within seconds!
      </strong>
    </p> */}
    {/* <p>
      {" "}
      You should use a <em>different</em> connection for <em>each</em> app you
      connect with your Rizful node. We recommend you{" "}
      <strong>
        name your connection for the app you intend to use it with
      </strong>
      ...
    </p>
    <SimpleImage h={150} src="docs_images/nwc-connection-change-name.png" />
    <p>
      After you give your connection a unique name, and adjust the budget
      settings as you wish, use the{" "}
      <Code style={{ backgroundColor: "var(--mantine-color-gray-8)" }}>
        Save Connection
      </Code>{" "}
      button.
    </p>
    <SimpleImage src="docs_images/save-nwc-connection.png" h={100} />

    <p>
      {" "}
      You can now use the{" "}
      <Code style={{ backgroundColor: "green" }}>
        <IconApps
          style={{
            width: "1.2em",
            height: "1.2em",
            position: "relative",
            left: "-1px", // Adjusts horizontal position (nudge left)
            top: "4px", // Adjusts vertical position (nudge down)
          }}
        />{" "}
        Get Connection Code
      </Code>{" "}
      button. You will then get a code that looks like this:
    </p> */}
    <p> You'll get a code that looks like this:</p>
    <code
      style={{
        wordWrap: "break-word", // Ensures the word wraps to the next line
        wordBreak: "break-word", // Breaks the word if it overflows
        whiteSpace: "normal", // Allows text wrapping
      }}
    >
      nostr+walletconnect://p&9XTp@dGjsUE5BwM....
    </code>
    <p></p>
    <p>
      {" "}
      Be careful with this code. Anyone who has it could spend funds from your
      Rizful node. Only paste it into browser extensions (like Alby) or mobile
      apps (like Yakihonne, Damus, Primal, etc.), that you trust. Don't paste it
      into random websites.
    </p>

    <p>(Note: If you see that the "Apps" button is disabled, like this... </p>
    <DocsButton
      ariaLabel="add apps"
      text="Apps"
      leftSection={<IconApps />}
      disabled={true}
    />
    <p>
      ...this means you still need to{" "}
      <a href="/docs/getting-inbound#inbound-from-rizful-lsp">
        get inbound capacity
      </a>
      .)
    </p>

    <h3 id="hold-invoices">Hold invoices (NWC-03)</h3>
    <p>
      Every Rizful NWC connection, including receive-only ones, supports{" "}
      <Code>make_hold_invoice</Code>, <Code>settle_hold_invoice</Code> and{" "}
      <Code>cancel_hold_invoice</Code>, and sends the{" "}
      <Code>hold_invoice_accepted</Code> notification. Your app creates the
      preimage and sends only its hash; Rizful cannot accept the payment
      without the preimage your app keeps.
    </p>
    <p>
      Once a payment arrives, <strong>two deadlines</strong> apply, and
      whichever comes first ends the hold:
    </p>
    <ul>
      <li>
        <Code>settle_deadline</Code>: a block height. It is the height at which
        the Lightning node cancels the payment on its own (18 blocks before
        the payer's HTLC expires), so settle before it. It never moves later.
      </li>
      <li>
        <Code>metadata.rizful_decision_deadline</Code>: a unix time. Rizful's
        own decision window (currently 2 hours from the payment arriving). If
        your app has not settled or canceled by then, Rizful cancels and the
        payer is refunded. This is almost always the earlier of the two.
      </li>
    </ul>
    <p>
      Limits: a minimum amount (currently 1,000 sats), a maximum invoice expiry
      of 24 hours, <Code>min_cltv_expiry_delta</Code> between 144 and 288, and a
      small number of hold invoices open and payments waiting per account.
      Only the connection that created a hold invoice can cancel it over NWC;
      settling works from any connection of the same wallet, because it needs
      the preimage. <Code>lookup_invoice</Code> reports a held payment as{" "}
      <Code>accepted</Code> and a canceled one as <Code>failed</Code>.
    </p>
  </TypographyStylesProvider>
);
